import { SiteSearchBoxModel } from './model';
import { SiteSearchBoxView } from './view';
import vent from '../lib/site-search-events';
import siteSearchService from '../lib/site-search-service';

export const tagName = 'search-box';

export default class SearchBoxElement extends HTMLElement {
    constructor() {
        super();

        window.addEventListener('popstate', (event) => {
            if (event.state) {
                siteSearchService.statePopGetData();
                // Trigger query-changed
                vent.trigger('query-changed');
            }
        });
    }

    async connectedCallback() {
        const view = new SiteSearchBoxView({
            el: this,
            model: new SiteSearchBoxModel(),
        });

        siteSearchService.setInitialState();
    }
}

customElements.define(tagName, SearchBoxElement);
